import { createContext, useEffect, useState } from "react";

export const AuthContext = createContext();

export const AuthProvider = ({ children }) => {
  const [user, setUser] = useState(null);
  const [roles, setRoles] = useState([]);
  const [loading, setLoading] = useState(true);

  // Restore roles/user when application starts
  useEffect(() => {
    const savedUser = localStorage.getItem("authUser");

    if (savedUser) {
      try {
        const parsedUser = JSON.parse(savedUser);

        setUser(parsedUser);
        setRoles(parsedUser.roles || []);
      } catch {
        localStorage.removeItem("authUser");
      }
    }

    setLoading(false);
  }, []);

  // Login
  const login = (userData) => {
    setUser(userData);
    setRoles(userData.roles || []);

    localStorage.setItem(
      "authUser",
      JSON.stringify(userData)
    );
  };

  // Logout
  const logout = async () => {
    try {
      // Call your backend logout API here
      // await authService.logoutAsync();
    } finally {
      setUser(null);
      setRoles([]);

      localStorage.removeItem("authUser");
    }
  };

  const hasRole = (role) => {
    return roles.some(
      x => x.toLowerCase() === role.toLowerCase()
    );
  };

  const hasAnyRole = (requiredRoles) => {
    return requiredRoles.some(role =>
      hasRole(role)
    );
  };

  return (
    <AuthContext.Provider
      value={{
        user,
        roles,
        loading,

        login,
        logout,

        hasRole,
        hasAnyRole
      }}
    >
      {children}
    </AuthContext.Provider>
  );
};